import { UITooltip } from "../../_app/components";
import { Policy as PolicyIcon } from "../../_app/components/icons";

const PcrfIndicator = ({ cli }: { cli?: string }) => (
  <UITooltip title="This product is managed via PCRF">
    <PolicyIcon fontSize="small" color="primary" data-cy={`pcrf-indicator-${cli}`} />
  </UITooltip>
);

export default PcrfIndicator;
